import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LandingNav } from '../components/Nav';
import SiteFooter from '../components/SiteFooter';
import PricingPlansCore from '../components/PricingPlansCore';
import './Pricing.css';

const DEFAULT_META_DESCRIPTION =
  'OrivonAI — Your companion for every chapter of your journey. Fertility, pregnancy, motherhood, and more.';
const PRICING_DOC_TITLE = 'Pricing — OrivonAI';
const PRICING_META_DESCRIPTION =
  'OrivonAI pricing — Bloom membership for individuals and Enterprise for organizations. Join the waitlist for launch updates.';

export default function Pricing() {
  useEffect(() => {
    const meta = document.querySelector('meta[name="description"]');
    const prevTitle = document.title;
    const prevDesc = meta ? meta.getAttribute('content') : '';
    document.title = PRICING_DOC_TITLE;
    if (meta) meta.setAttribute('content', PRICING_META_DESCRIPTION);
    return () => {
      document.title = prevTitle;
      if (meta) meta.setAttribute('content', prevDesc ?? DEFAULT_META_DESCRIPTION);
    };
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: 'var(--sand)' }}>
      <header className="pricing-sticky-top">
        <div className="pricing-founding-banner" role="region" aria-label="Founding member pricing">
          <p className="pricing-founding-banner-text">
            🌸 Limited Founding Member Pricing · Join the waitlist to claim $19/month for life + founding member perks.{' '}
            <Link to="/signup?source=pricing-banner" className="pricing-founding-banner-link">
              Join now →
            </Link>
          </p>
        </div>
        <div className="pricing-sticky-top-nav">
          <LandingNav positionMode="static" />
        </div>
      </header>

      <section className="pricing-section-band" style={{ padding: 0, scrollMarginTop: 88 }}>
        <PricingPlansCore embedded={false} showTrustBar showFaq />
      </section>

      <SiteFooter />
    </div>
  );
}
